/* eslint-disable no-console */

export function consoleLog<T>(value: T): T {
    console.log(value)
    return value
}

export function consoleError<T>(value: T): T {
    console.error(value)
    return value
}
